/** @format */

import { Chain, DCSG_CONSTANTS, UtilityService } from '@dcsg-ngx-ecommerce/core';
import { Component, Input, OnInit } from '@angular/core';

import { HOME_CONSTANTS } from '../../app.constants';
import { IQuickviewCta } from '../quickview-cta/quickview-cta.interface';
import { IStory } from './story.interface';
import { TaggingService } from '@dcsg-ngx-ecommerce/engage/service/tagging.service';

@Component({
	selector: 'home-story',
	templateUrl: './story.component.html',
	styleUrls: ['./story.component.scss']
})
export class StoryComponent implements OnInit {
	@Input() data: IStory[];
	@Input() addlData: any;
	@Input() variant: any;
	@Input() ctaIndex: number;
	@Input() altText: string;
	@Input() title: string;
	@Input() itemTitle: string;
	@Input() willLazyLoad = true;
	@Input() quickviewCta: IQuickviewCta;
	@Input() inputPosition: number;
	@Input() ctaCombined: any[];

	public copyboxPositionStyle = {
		left: 'copybox--left',
		center: 'copybox--center',
		right: 'copybox--right',
		noMobile: 'copybox-no-mobile-image hmf-mt-m hmf-mt-s-0'
	};

	public componentContainerVariant = {
		full: 'col-12 hmf-px-0 copybox-image-load',
		multi: 'col-6 col-lg-3 hmf-px-s',
		multi2Section: 'col-12 col-sm-6 hmf-px-s',
		multi3Section: 'col-12 col-sm-6 col-lg-4 hmf-px-s'
	};

	private contentVariant = {
		full: ' copybox copybox-mobile-width hmf-px-l hmf-py-m-s',
		multi: ''
	};

	public buttonStylingVariant = {
		full: 'button-full-mobile-width button-full-desktop-width hmf-mt-xxxs hmf-mt-m-0 hmf-text-align-center hmf-mb-xxxs',
		multi: 'hmf-px-0 hmf-my-xxxs hmf-my-m-0 hmf-py-m-xxs text-nowrap',
		multiCta3orMore: 'multi-button-width'
	};

	private buttonPositionStylingVariant = {
		left: 'hmf-mr-m-xs hmf-px-0',
		right: 'hmf-ml-m-xs hmf-px-0',
		center: 'hmf-px-s-xxs',
		inlineLeft: 'hmf-px-s-xxs',
		inlineRight: 'hmf-px-s-xxs'
	};

	private buttonContainerVariant = {
		full: 'hmf-justify-content-center',
		multi: 'hmf-justify-content-around'
	};

	private badgeStylingVariant = {
		full: 'hmf-mb-s w-100 badge-hero-overhang',
		multi: 'text-md-left hmf-mb-xxs badge-multi'
	};

	private parentVariant = {
		inlineLeft:
			'hmf-display-flex hmf-flex-column hmf-flex-md-row-reverse hmf-align-items-stretch',
		inlineRight: ' hmf-display-flex hmf-flex-column hmf-flex-md-row hmf-align-items-stretch',
		float: ' hmf-flex-column hmf-align-items-center'
	};

	public textAlignmentVariant = {
		withInformationalsContent: 'w-100 hmf-position-relative hmf-pt-0 hmf-pt-m-0 hmf-mb-l',
		default: 'w-100 hmf-position-relative hmf-text-align-center hmf-mb-l'
	};

	public dataLength: any;
	public targetService: any;
	public chainAbr: string;
	public altTagService: any;
	public buttonVariant: any;
	public copyboxClasses: any;
	public buttonStyling: any;
	public badgeStyling: any;
	public buttonContainer: any;
	public componentContainer: any;
	public isGGStaticPage: boolean;
	public isInline: boolean;
	public backdropColor: any;
	public setTextAlignment: any;
	public ggStaticColors = HOME_CONSTANTS.ggStaticColors;

	constructor(
		public taggingService: TaggingService,
		private chain: Chain,
		private utilityService: UtilityService
	) {
		this.altTagService = taggingService.altTag;
		this.targetService = this.utilityService.target;
		this.chainAbr = this.chain.chainIdentifierAbbr;
	}

	ngOnInit() {
		this.backdropColor = this.returnColorIfUsed();
		this.isGGStaticPage = this.utilityService.ggStaticPage(this.addlData.isStaticPage);
		this.dataLength = Object.keys(this.data).length;
		this.returnCombinedCtas(this.dataLength);
		this.variant = this.data[0].textBoxPosition ? 'full' : 'multi';
		this.componentContainer = this.componentContainerVariant[this.variant];
		this.checkForinlineStyling();
		if (this.variant === 'full') {
			this.fullStoryVariant();
			this.copyboxVariants();
		} else {
			this.multiStoryVariant();
			this.multiComponentContainerVariant();
		}
		this.setTextAlignment = this.setTextAlignmentToWysiwyg();
		this.badgeStyling = this.badgeStylingVariant[this.variant];
	}

	fullStoryVariant() {
		this.buttonVariant = this.data[0].buttonStyle ? this.data[0].buttonStyle : 'secondary';
		this.buttonStyling = `${this.buttonPositionStylingVariant[this.data[0].textBoxPosition]} ${
			this.buttonStylingVariant[this.variant]
		}`;
	}

	copyboxVariants() {
		this.copyboxClasses = this.contentVariant[this.variant];
		this.copyboxClasses += `${this.copyboxClasses} ${
			this.copyboxPositionStyle[this.data[0].textBoxPosition]
		}`;
		const transparent =
			typeof this.data[0].textBlockBackground === 'string'
				? this.data[0].textBlockBackground === 'true'
				: (this.data[0].textBlockBackground as boolean);
		this.copyboxClasses += transparent ? '' : ' transparent-background';
		this.copyboxClasses += ` ${this.data[0].textColor}-text`;

		if (this.isInline) {
			this.copyboxClasses += ' inline-box hmf-justify-content-center';
		} else if (this.variant === 'full') {
			this.copyboxClasses += ' float-box hmf-position-absolute';
		}

		// if hero layout is not inline left/right - vertically center mobile copybox unless a different value is provided
		this.copyboxClasses += this.data[0].mobileTextBoxVerticalPosition
			? ` mobile-copybox-vertical-${this.data[0].mobileTextBoxVerticalPosition}`
			: ` mobile-copybox-vertical-bottom`;

		if (this.data[0].mobileTextBoxVerticalPosition === 'center') {
			this.copyboxClasses += ' hmf-m-m ';
		}

		this.checkForNoMobileImages();
	}

	checkForinlineStyling() {
		if (
			this.data[0].textBoxPosition === 'inlineLeft' ||
			this.data[0].textBoxPosition === 'inlineRight'
		) {
			this.isInline = true;
			this.componentContainer += this.parentVariant[this.data[0].textBoxPosition];
		} else {
			this.componentContainer += this.parentVariant['float'];
		}
		this.buttonContainer = this.buttonContainerVariant[this.variant];
	}

	checkForNoMobileImages() {
		let getValuesOfVisualAssets = [];
		if (this.data[0]?.visualAssets && this.data[0]?.visualAssets[0]) {
			getValuesOfVisualAssets = Object.values(this.data[0]?.visualAssets[0]).filter(
				(imageType: any) => {
					return imageType.type && imageType.type === 'mobileImageUpload';
				}
			);
		}

		if (!this.data[0]?.mobileImg && getValuesOfVisualAssets.length === 0 && !this.isInline) {
			this.copyboxClasses += `${this.copyboxClasses} ${this.copyboxPositionStyle.noMobile}`;
		}
	}

	multiStoryVariant() {
		this.buttonVariant = 'tertiary';
		this.buttonStyling = this.buttonStylingVariant[this.variant];
		if (this.data[0].cta && this.data[0].cta.length >= 3) {
			this.buttonStyling = `${this.buttonStylingVariant[this.variant]} ${
				this.buttonStylingVariant.multiCta3orMore
			}`;
		}
	}

	multiComponentContainerVariant() {
		// full length story without the copybox
		if (this.dataLength === 1 && !this.data[0].textBoxPosition) {
			this.componentContainer = `${this.componentContainerVariant.full}`;
		}
		if (this.dataLength === 2) {
			this.componentContainer = `${this.componentContainerVariant.multi2Section}`;
		}
		if (this.dataLength === 3) {
			this.componentContainer = `${this.componentContainerVariant.multi3Section}`;
		}
	}

	showButton() {
		return this.chainAbr !== 'gg';
	}

	setWidthParamForImage() {
		return `${DCSG_CONSTANTS.maxAppWidth / this.dataLength}px`;
	}

	createTag(parentIndex: number, ctaIndex: number, ctaText: string, altText: string) {
		return this.taggingService.createTag(
			this.addlData.tagSectionNum,
			this.addlData.widgetTypeTag,
			parentIndex,
			ctaIndex,
			ctaText,
			altText,
			null,
			false,
			'hp'
		);
	}

	returnColorIfUsed() {
		let classReturner;
		const color = this.data[0].textColor;
		this.data[0].contentBackgroundColor && this.data[0].textColor
			? (classReturner = `backdrop ${color}-text`)
			: (classReturner = '');

		return classReturner;
	}

	setTextAlignmentToWysiwyg() {
		if (!this.data[0]?.informationalsContent) {
			return this.textAlignmentVariant.default;
		}
		if (this.data[0]?.textAlignment === 'center' && this.data[0]?.informationalsContent) {
			return this.textAlignmentVariant.default;
		}
		if (this.data[0]?.textAlignment === 'left' && this.data[0]?.informationalsContent) {
			return this.textAlignmentVariant.withInformationalsContent;
		}
		if (this.data[0]?.textAlignment === 'right' && this.data[0]?.informationalsContent) {
			return (this.textAlignmentVariant.withInformationalsContent += ' text-right');
		}
	}

	returnCombinedCtas(dataLength: number) {
		for (let i = 0; i < dataLength; i++) {
			if (this.data[i]?.cta && this.data[i]?.quickviewCta) {
				this.data[i].cta = [].concat(this.data[i].cta, this.data[i].quickviewCta);
			}
		}
	}
}
